import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectRegulation, regulationListUpdateSelected } from "../../app/actions/regulationActions";
import { registerPanelViewInterest } from "../../app/helpers/intentTrackingHelper";
import ReadMoreReadLess from "../generic-read-more/ReadMoreReadLess";
import L5ModalRegulation from "./L5ModalRegulation";
import { debugLogPages } from "../../app/helpers/debugHelper";
import { useTranslation } from "react-i18next";
import SemanticSimilarityBadge from "./SemanticSimilarityBadge";
import { canShowIntegrationDashboardBridge } from "../../app/helpers/semanticSearchConfigHelper";

const L4CardRegulation = ({ data, moduleSelected }) => {
  
   debugLogPages(':: L4CardRegulation');

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const configuration = useSelector((state) => state.configuration);
  const showSelect = canShowIntegrationDashboardBridge(configuration, 'regulation');

  const [popupInformationTechIsOpen, setPopupInformationTechIsOpen] = useState(false);
  const isChecked = data.isSelected;

  const closeModal = () => {
    setPopupInformationTechIsOpen(false);
  }

  const handleViewRegulation = (e) => {
    e.preventDefault();
    dispatch(selectRegulation(data));
    registerPanelViewInterest(dispatch, 'regulation', data);
    navigate(`/end-user-search/view-regulation`);
  };

  const PreviewImageShow = () => {
  // Imagen por defecto
  //const defaultImg = "/Modulos/TecBC.png";
  const defaultImg = '/images/logo_teccc_no_disponible.png'

  const handleImgError = (e) => {
    // Si la imagen falla, reemplazamos el src por la de defecto
    e.target.src = defaultImg;
    // Opcional: puedes quitar el atributo onError para evitar bucles si la de defecto también falla
    e.target.onerror = null; 
  };

  if (data.ModuleFile_To_Regulation && data.ModuleFile_To_Regulation.length > 0) {
    return (
      <img 
        src={data.ModuleFile_To_Regulation[0].url} 
        alt="file" 
        onError={handleImgError} // <-- El truco está aquí
      />
    );
  } else {
    return (
      <div>
        <img src={defaultImg} width="300px" alt="technology" />
      </div>
    );
  }
};

  const handlePopupSwall = (e) => {
    e.preventDefault();
    registerPanelViewInterest(dispatch, 'regulation', data);

    setPopupInformationTechIsOpen(true);
  };

  const handleToggle = () => {
    dispatch(regulationListUpdateSelected(data.id));
  };

  return (
    <li className="cards__item">
      <div className="card"
      >
        {showSelect && (
          <div>
            <label>
              <input type="checkbox" checked={Boolean(isChecked)} onChange={handleToggle} />
              <div className="espacioComparar">
                {isChecked ? t('general.card-selected') : t('general.card-select')}
              </div>
            </label>
          </div>
        )}
        <div className="card__image" onClick={handlePopupSwall}>
          <PreviewImageShow />
        </div>
        <div className="card__content">
          <SemanticSimilarityBadge data={data} moduleKey="regulation" />
          <div className="card__title">
            <ReadMoreReadLess
              className='read-more-less'
              buttonClassName='btn-read-more-less'
              expandLabel="Leer más" 
              collapseLabel="Leer menos" 
              limit={100}
            >
              {data && data.name}
            </ReadMoreReadLess>
          </div>
          <br />
          <div className="card__text">
            <ReadMoreReadLess
              className='read-more-less'
              buttonClassName='btn-read-more-less'
              expandLabel="Leer más" 
              collapseLabel="Leer menos" 
              limit={100}
            >
              {data && data.legal_instrument}
            </ReadMoreReadLess>
          </div>

          <button className="btn btn--block button-color-view" onClick={handleViewRegulation}>
            {t("buttons.view")}
          </button>

        </div>
      </div>

      <L5ModalRegulation
        modalIsOpen={popupInformationTechIsOpen}
        closeModal={closeModal}
        data={data}
        moduleSelected={moduleSelected}
      />

    </li>
  );
};

export default L4CardRegulation;
